<template>
  <el-card>
    <el-form class="" label-width="120px" label-position="right">
      <el-form-item label="景点名称：" prop="sceneryName">
        {{ formData.sceneryName }}
      </el-form-item>
      <el-form-item label="所属公园：" prop="projectName">
        {{ formData.projectName }}
      </el-form-item>
      <el-form-item label="是否网红景点：" prop="isNetRed">
        {{ formData.isNetRed === '1' ? '是' : '否' }}
      </el-form-item>
      <el-form-item label="景点封面图：" prop="fileList">
        <custom-upload v-model="formData.fileList" disabled></custom-upload>
      </el-form-item>
      <el-form-item label="景点介绍：" prop="description">
        <custom-editor ref="editor" readonly v-model="formData.description"></custom-editor>
      </el-form-item>
      <el-form-item label="位置信息：" prop="resourcesLocationList">
        <CustomMapMarker ref="map" :isClickPolyon="false" disabled :value=formData.resourcesLocationList>
        </CustomMapMarker>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
import { handleTLnglatList } from '@/utils/util'
import CustomEditor from '@/components/CustomEditor.vue'
export default {
  name: 'ScenicspotDetail',
  components: {
    CustomEditor
  },
  filters: {
    previewList: function (value) {
      return value.map((item) => {
        return item.filePrefix + item.fileUrl
      })
    }
  },
  data() {
    return {
      formData: {
        projectId: '',
        sceneryName: '',
        isNetRed: '',
        isFull: '',
        description: '',
        fileList: [],
        resourcesLocationList: []
      }
    }
  },
  computed: {
    sceneryId() {
      return this.$route.params.sceneryId
    },
    projectId() {
      return this.$route.query.projectId || ''
    }
  },
  created() {
    if (this.sceneryId) {
      this.loadData()
    }
  },
  mounted() {
    this.mapRef = this.$refs.map
    this.projectId && this.drawPolyon(this.projectId)
  },
  methods: {
    // 围栏
    drawPolyon(projectId) {
      this.$axios.get(this.$apis.park.selectParkLocationByObjectId, {
        objectId: projectId
      }).then(res => {
        const parkInfo = res.parkInfo || {}
        // 绘制公园中心点
        // this.center = [{ longitude: parkInfo.longitude, latitude: parkInfo.latitude }]
        // 绘制电子围栏
        this.mapRef.setZoomAndCenter([+parkInfo.longitude, +parkInfo.latitude], 15)
        this.fenceList = handleTLnglatList(res.parkLocation || [])
        // 重新绘制前清除所有
        this.mapRef.clearPolyon()
        this.mapRef.drawPolyons(this.fenceList)
      }).finally(() => {
        this.loading = false
      })
    },
    loadData() {
      this.$axios.get(this.$apis.tourist.selectSceneryBySceneryId, {
        sceneryId: this.sceneryId
      }).then(res => {
        this.formData = res || {}
      })
    }
  }
}
</script>

<style scoped lang="scss"></style>
